const initialState = {
    PROFILE_DATA: {},
    OCR_COUNTRIES: [],
};

export default function Reducer(state = initialState, action) {

    switch (action.type) {
        case "UPDATE_PROFILE_DATA":
            return {
                ...state,
                PROFILE_DATA: action.payload,
            };
        case "UPDATE_OCR_COUNTRIES":
            return {
                ...state,
                OCR_COUNTRIES: action.payload,
            };
        default:
            return state;
    }
}
